import './Herowrapper.css';
import { Text, Box, Image } from "@mantine/core";
// import Brochure from '../Assets/Ourbrochure.pdf';
import { Alert, Carousel } from "antd";
import Screenfirst from '../Images/Screenfirst.png';
import Screentwo from '../Images/Screentwo.png';
import Screenthird from '../Images/Screenthree.png';
import Marquee from 'react-fast-marquee';

export default function HeroSection() {

    // const [opened, { open, close }] = useDisclosure(false);
    // const [Inputs, setinputs] = useState({
    //     Subject: 'This mail intended by GV InfoTech for consultation.',
    //     Name: '',
    //     Mobile_number: '',
    //     Email_ID: '',
    //     Message: ''
    // });
    // const [prefferddate, setpreffereddate] = useState('');
    // const [prefferdtime, setprefferedtime] = useState('');
    // const [loading, setloading] = useState(false);
    // const [showalert, setshowalert] = useState(false);
    // const Handleinputchange = (e) => {
    //     const { name, value } = e.target;
    //     setinputs({ ...Inputs, [name]: value });
    // }

    // const Submit_Consultancy_Form = async () => {
    //     const { Subject, Name, Mobile_number, Email_ID, Message } = Inputs;
    //     if (!Name || !Mobile_number || !Email_ID) {
    //         message.error("Please fill all required fields");
    //         return;
    //     }
    //     if (prefferddate === '') {
    //         message.error('Please select your preferred date');
    //         return
    //     }
    //     if (prefferdtime === '') {
    //         message.error('Please select your preferred time');
    //         return
    //     }
    //     else {
    //         setloading(true);
    //         // ✅ Format date & time using dayjs
    //         const formattedDate = dayjs(prefferddate).format('DD-MM-YYYY');
    //         const formattedTime = dayjs(prefferdtime).format('h:mm A');

    //         const res = await fetch('https://formspree.io/f/xgvkbrjq', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({ Subject, Name, Mobile_number, Email_ID, Prefered_date: formattedDate, Prefered_time: formattedTime, Message })
    //         })
    //         if (res.status === 'ok' || res.status === 200) {
    //             message.success('Thanks form submitting consultation form. We will be right back your date & time!', 4);
    //             setinputs({
    //                 Subject: 'This mail intended by GV InfoTech Contact us.',
    //                 Name: '',
    //                 Mobile_number: '',
    //                 Email_ID: '',
    //                 Message: ''
    //             });
    //             setpreffereddate('');
    //             setprefferedtime('');
    //             setloading(false);
    //             setshowalert(true);
    //             setTimeout(() => {
    //                 setshowalert(false);
    //             }, 4000);
    //             close();
    //             return
    //         } else {
    //             message.error('oops! something went wrong.');
    //             setloading(false);
    //             return
    //         }

    //     }
    // }


    // function OpenBrochurepdf() {
    //     window.location.href = Brochure
    // }
    return (
        <>
            {/* <Modal opened={opened} onClose={close} title="Book a free consultation">
                <Box>
                    <Alert message="Your form successfully submitted!" type="success" showIcon style={{ display: showalert ? 'flex' : 'none' }} />
                    <LoadingOverlay
                        visible={loading}
                        zIndex={1000}
                        overlayProps={{ radius: 'sm', blur: 2 }}
                        loaderProps={{ color: 'indigo', type: 'bars' }}
                    />
                    <TextInput placeholder="Name" label="Please enter your name" radius={'md'} name="Name" value={Inputs.Name} onChange={Handleinputchange} withAsterisk required mt={'xs'}></TextInput>
                    <TextInput placeholder="Mobile no" label="Please enter your mobile number" radius={'md'} name="Mobile_number" value={Inputs.Mobile_number} onChange={Handleinputchange} withAsterisk required mt={'sm'} minLength={10} maxLength={10}></TextInput>
                    <TextInput placeholder="Email ID" label="Please enter your Email id" radius={'md'} name="Email_ID" value={Inputs.Email_ID} onChange={Handleinputchange} withAsterisk required mt={'sm'}></TextInput>
                    <Input.Wrapper label="Please select your preferred date" withAsterisk mt={'xs'}>
                        <DatePicker style={{ marginLeft: '5px' }} format={'DD-MM-YYYY'} name="Prefered_date" value={prefferddate} onChange={(date) => setpreffereddate(date)} />
                    </Input.Wrapper>
                    <Input.Wrapper label="Please select your preferred time" withAsterisk mt={'xs'}>
                        <TimePicker style={{ marginLeft: '5px' }} use12Hours format="h:mm a" name="Prefered_time" value={prefferdtime} onChange={(time) => setprefferedtime(time)} />
                    </Input.Wrapper>
                    <Textarea placeholder="Something..." label="Any message (Optional)" radius={'md'} mt={'sm'} name="Message" value={Inputs.Message} onChange={Handleinputchange} autosize minRows={3}></Textarea>
                    <Button mt={'md'} color="black" size="md" radius={'lg'} fullWidth loading={loading} disabled={loading} onClick={Submit_Consultancy_Form}>Submit consultation form</Button>
                </Box>
            </Modal> */}
            <Carousel autoplay={{ dotDuration: true }} autoplaySpeed={5000}>
                <div>
                    <Image
                        src={Screenfirst}
                        alt="Hero"
                        h={'90vh'}
                        fit='center'
                        w={'100%'}
                    />
                </div>
                <div>
                    <Image
                        src={Screentwo}
                        alt="Hero"
                        h={'90vh'}
                        fit='center'
                        w={'100%'}
                    >
                    </Image>
                </div>
                <div>
                    <Image
                        src={Screenthird}
                        alt="Hero"
                        h={'90vh'}
                        fit='center'
                        w={'100%'}
                    >
                    </Image>
                </div>
                {/* <div>
                    <h3 style={contentStyle}>4</h3>
                </div> */}
            </Carousel>
            <Box>
                <Alert banner type="info" icon className='banner' message={<><Marquee gradient={false}><Text fw={700} mr={'xs'}>Trending Now </Text>
                    <Text fw={500} mr={'xs'}>GV InfoTech.org- 30+ Local & Global Projects </Text> <Text fw={500} mr={'xs'}>2+ Countires Served with Digital Excellence </Text> <Text fw={500} mr={'xs'}>100+ Technology Experts Driving innovation</Text></Marquee></>} />
            </Box>
        </>
    );
}
